export default "__VITE_ASSET__CZ8$kHi0__"